import { verisureService } from './api';

const OFFLINE_QUEUE_KEY = 'elemental_offline_logs_queue';

export const offlineSyncService = {
  // Save log payload to offline queue
  saveToOfflineQueue: (logData: any) => {
    try {
      const existing = JSON.parse(localStorage.getItem(OFFLINE_QUEUE_KEY) || '[]');
      existing.push({
        id: `offline-${Date.now()}`,
        logData,
        createdAt: new Date().toISOString()
      });
      localStorage.setItem(OFFLINE_QUEUE_KEY, JSON.stringify(existing));
      console.log('[OfflineSync] Log saved to local offline storage');
    } catch (err) {
      console.error('[OfflineSync] Failed to write to localStorage:', err);
    }
  },

  // Get count of pending offline items
  getPendingCount: (): number => {
    try {
      const existing = JSON.parse(localStorage.getItem(OFFLINE_QUEUE_KEY) || '[]');
      return existing.length;
    } catch {
      return 0;
    }
  },

  // Flush queued offline logs to Firestore
  flushOfflineQueue: async (): Promise<number> => {
    if (!navigator.onLine) return 0;

    try {
      const existing = JSON.parse(localStorage.getItem(OFFLINE_QUEUE_KEY) || '[]');
      if (existing.length === 0) return 0;

      console.log(`[OfflineSync] Flushing ${existing.length} offline log(s) to cloud...`);
      let successCount = 0;
      const remaining: any[] = [];

      for (const item of existing) {
        try {
          await verisureService.logMaintenance(item.logData);
          successCount++;
        } catch (err) {
          console.error('[OfflineSync] Error syncing item, keeping in queue:', err);
          remaining.push(item);
        }
      }

      localStorage.setItem(OFFLINE_QUEUE_KEY, JSON.stringify(remaining));
      console.log(`[OfflineSync] Successfully synced ${successCount} item(s)`);
      return successCount;
    } catch (err) {
      console.error('[OfflineSync] Error flushing queue:', err);
      return 0;
    }
  },

  // Initialize auto-sync listener when app loads / comes online
  initAutoSync: () => {
    window.addEventListener('online', () => {
      console.log('[OfflineSync] Internet connection restored. Attempting auto-sync...');
      offlineSyncService.flushOfflineQueue();
    });

    // Check on startup if online
    if (navigator.onLine) {
      offlineSyncService.flushOfflineQueue();
    }
  }
};
